import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { DOMAIN_IN_CART_SPEC, cartSupportedTlds } from '../../constants/eligibility';
import { DomainAvailabilityStatus } from '../../typing';
import { parseDomain } from '../../utils';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
export const isEligibleForDomainInCart = async _ref => {
  let httpClient = _ref.httpClient,
    request = _ref.request;
  const msid = request.msid,
    domainName = request.domainName;
  const _ref2 = getPremiumEssentialsSafe() ?? {},
    biLogger = _ref2.biLogger,
    referralAdditionalInfo = _ref2.referralAdditionalInfo,
    panorama = _ref2.panorama;
  try {
    var _experimentsResponse$;
    const _await$dynamicLoadApi = await dynamicLoadApiQueries(httpClient),
      domainAvailability = _await$dynamicLoadApi.domainAvailability,
      domainsAccount = _await$dynamicLoadApi.domainsAccount,
      experiments = _await$dynamicLoadApi.experiments;
    const _parseDomain = parseDomain(domainName),
      tld = _parseDomain.tld,
      subdomain = _parseDomain.subdomain,
      formattedInput = _parseDomain.formattedInput;
    if (!cartSupportedTlds.has(tld) || subdomain || !msid) {
      return {
        isEligible: false
      };
    }
    const _await$Promise$all = await Promise.all([domainAvailability({
        domainName: formattedInput
      }), domainsAccount({
        msid
      }), experiments({
        experiments: [DOMAIN_IN_CART_SPEC]
      })]),
      _await$Promise$all$ = _await$Promise$all[0],
      status = _await$Promise$all$.status,
      isPremiumDomain = _await$Promise$all$.premium,
      _await$Promise$all$2 = _await$Promise$all[1],
      isPremiumSite = _await$Promise$all$2.isPremiumSite,
      isSiteBelongsToAccount = _await$Promise$all$2.isSiteBelongsToAccount,
      hasAmountDiscountCoupons = _await$Promise$all$2.hasAmountDiscountCoupons,
      experimentsResponse = _await$Promise$all[2];
    const isDomainInCartEnabled = !!((_experimentsResponse$ = experimentsResponse.experiments) != null && _experimentsResponse$[DOMAIN_IN_CART_SPEC]);
    const isAvailableForPurchase = status.includes(DomainAvailabilityStatus.AVAILABLE_FOR_PURCHASE);
    const isEligible = Boolean(isAvailableForPurchase && !isPremiumDomain && isPremiumSite && !hasAmountDiscountCoupons && isSiteBelongsToAccount);
    if (isEligible && biLogger) {
      const _await$import = await import('@wix/bi-logger-premium-data-domains/v2'),
        domainPurchaseFlowCartExposureSrc17Evid885 = _await$import.domainPurchaseFlowCartExposureSrc17Evid885;
      biLogger.report(domainPurchaseFlowCartExposureSrc17Evid885({
        domain: domainName,
        isCartActive: isDomainInCartEnabled,
        msid,
        referralAdditionalInfo
      }));
    }
    return {
      isEligible: isEligible && isDomainInCartEnabled
    };
  } catch (error) {
    panorama == null || panorama.errorMonitor().reportError(error);
    return {
      isEligible: false
    };
  }
};
//# sourceMappingURL=isEligibleForDomainInCart.js.map